import {
  Grid,
  Typography,
  Button,
  Dialog,
  DialogTitle,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import queryString from "query-string";
import { Link, useHistory, useLocation } from "react-router-dom";
import {
  sum,
} from "../../utils/helpers";
import useQuery from "../../utils/hook/useQuery";
import handleError from "../../utils/handleError";
import {
  getAllTicket,
  getStatusCounts,
  getStatusCountsByCategory,
} from "../../api/ticket/get";
import CreateTicket from "./components/registerTicket";
import type { Filter } from "../../utils/listDaynamicFilter";
import {
  mdiAccountOutline,
  mdiStateMachine,
  mdiCalendar,
  mdiHomeSearchOutline,
} from "@mdi/js";
import SmallFilterBox from "../../components/SmallFilterBox";
import classes from "./index.module.css";


const Ticketing = (props) => {
  const { search } = useLocation();
  const history = useHistory();
  const filters: Filter[] = [
    {
      type: "input",
      id: "tracking.gte",
      label: "شماره تیکت از",
      icon: mdiAccountOutline,
    },
    {
      type: "input",
      id: "tracking.lte",
      label: "شماره تیکت تا",
      icon: mdiAccountOutline,
    },
    {
      type: "input",
      id: "department.name",
      label: "نام دپارتمان",
      icon: mdiAccountOutline,
    },
    {
      type: "input",
      id: "title.substring",
      label: "کلمه کلیدی عنوان",
      icon: mdiAccountOutline,
    },
    {
      type: "input",
      id: "linkId",
      label: "سفارش یا محموله",
      icon: mdiAccountOutline,
    },
    {
      type: "input",
      id: "creator.username",
      label: "نام سازنده",
      icon: mdiAccountOutline,
    },
    {
      type: "input",
      id: "assignee.username",
      label: "نام گیرنده",
      icon: mdiAccountOutline,
    },
    {
      type: "input",
      id: "partner.username",
      label: "نام پارتنر",
      icon: mdiAccountOutline,
    },
    {
      type: "input",
      id: "partner.id",
      label: "شناسه پارتنر",
      icon: mdiAccountOutline,
    },
    {
      type: "checkbox",
      id: "assignmentType.in",
      label: "‌مبدا ارسال",
      data: ["FFC", "PARTNER"],
      translateType: "ticket",
      icon: mdiStateMachine,
    },
    {
      type: "checkbox",
      id: "status.in",
      label: "وضعیت",
      data: [
        "OWNER_ANSWERED",
        "OPEN",
        "PENDING",
        "ASSIGNEE_ANSWERED",
        "CLOSED",
      ],
      translateType: "ticket",
      icon: mdiStateMachine,
    },
    {
      type: "checkbox",
      id: "priority.in",
      label: "الویت",
      data: ["LOW", "NORMAL", "HIGH", "CRITICAL"],
      translateType: "ticket",
      icon: mdiStateMachine,
    },
    {
      type: "date-picker",
      id: "createdAt.gte",
      label: "تاریخ ایجاد از",
      icon: mdiCalendar,
    },
    {
      type: "date-picker",
      id: "createdAt.lt",
      label: "تاریخ ایجاد تا",
      icon: mdiCalendar,
    },
    {
      type: "date-picker",
      id: "updatedAt.gte",
      label: "تاریخ ویرایش از",
      icon: mdiCalendar,
    },
    {
      type: "date-picker",
      id: "updatedAt.lt",
      label: "تاریخ ویرایش تا",
      icon: mdiCalendar,
    },
    {
      type: "input",
      id: "subject.body",
      label: "موضوع",
      icon: mdiHomeSearchOutline,
    },
  ];
  const { filtersValues, setFiltersValues } = useQuery({
    page: 0,
    size: 100,
    ...queryString.parse(search),
  });
  const [categoryCount, setCategoryCount] = useState();
  const [ticketCounts, setTicketCounts] = useState(0);
  const [openSize, setOpenSize] = React.useState(false as boolean);

  const [cardCounts, setCardCounts] = useState({});
  const [openMsg, setOpenMsg] = useState(false);
  const [loading, setLoading] = useState(true);
  const [finalizedTicketsList, setFinalTickets] = useState<any>([]);

  useEffect(() => {
    getCountByCategory();
  }, []);

  useEffect(() => {
    getTickets();
    gettingTicketCount(request);
  }, [filtersValues]);

  const getCountByCategory = async () => {
    try {
      const res = await getStatusCountsByCategory();
      setCategoryCount(res.data);
    } catch (error) {
      handleError(error);
    }
  };

  const getTickets = async () => {
    try {
      const res = await getAllTicket(filtersValues);
      setFinalTickets(res.data.content);
      setTicketCounts(res.data.totalCount);
    } catch (error) {
      handleError(error);
    }
  };

  const gettingTicketCount = async (actions: any) => {
    try {
      setLoading(true);
      const counts = await getStatusCounts();
      setCardCounts(counts.data);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  const request = {
    openCount: {
      status: "OPEN",
    },
    closeCount: {
      status: "CLOSED",
    },
    answeredCount: {
      status: "ASSIGNEE_ANSWERED",
    },
    ownerAnsweredCount: {
      status: "OWNER_ANSWERED",
    },
  };

  const handleCloseModal = () => {
    setOpenMsg(false);
  };

  const forwardToList = (filters: string[], custom?: string) => {
    console.log('======> filters : ',filters)
    if (filters.length > 1) {
      history.push(`/ticketing-list?advanceItem.in=${filters}&${custom}`);
    } else if (filters.length === 1) {
      history.push(`/ticketing-list?advanceItem=${filters[0]}&${custom}`);
    }
  };

  
  const statusMap = {
    REQUIRE_ATTENTION : [
      `FFC_FFC_SUPPORT_OPEN`,
      `FFC_SUPPORT_SUPPORT_OPEN`,
      `FFC_PARTNER_SUPPORT_OPEN`,
      `PARTNER_FFC_SUPPORT_OPEN`,
      `PARTNER_SUPPORT_SUPPORT_OPEN`,
      `PARTNER_PARTNER_SUPPORT_OPEN`,
      `FFC_FFC_SUPPORT_PENDING`,
      `FFC_SUPPORT_SUPPORT_PENDING`,
      `FFC_PARTNER_SUPPORT_PENDING`,
      `PARTNER_FFC_SUPPORT_PENDING`,
      `PARTNER_SUPPORT_SUPPORT_PENDING`,
      `PARTNER_PARTNER_SUPPORT_PENDING`,
      `FFC_FFC_SUPPORT_OWNER_ANSWERED`,
      `FFC_SUPPORT_SUPPORT_OWNER_ANSWERED`,
      `FFC_PARTNER_SUPPORT_OWNER_ANSWERED`,
      `PARTNER_FFC_SUPPORT_OWNER_ANSWERED`,
      `PARTNER_SUPPORT_SUPPORT_OWNER_ANSWERED`,
      `PARTNER_PARTNER_SUPPORT_OWNER_ANSWERED`,
      `SUPPORT_SUPPORT_SUPPORT_OPEN`,
      `SUPPORT_FFC_SUPPORT_OPEN`,
      `SUPPORT_PARTNER_SUPPORT_OPEN`,
      `SUPPORT_SUPPORT_SUPPORT_PENDING`,
      `SUPPORT_FFC_SUPPORT_PENDING`,
      `SUPPORT_PARTNER_SUPPORT_PENDING`,
      `SUPPORT_PARTNER_FFC_ASSIGNEE_ANSWERED`,
      `SUPPORT_SUPPORT_PARTNER_ASSIGNEE_ANSWERED`,
      `SUPPORT_SUPPORT_FFC_ASSIGNEE_ANSWERED`,
      `SUPPORT_PARTNER_PARTNER_ASSIGNEE_ANSWERED`,
      `SUPPORT_FFC_FFC_ASSIGNEE_ANSWERED`,
      `SUPPORT_FFC_PARTNER_ASSIGNEE_ANSWERED`,
      `FFC_PARTNER_PARTNER_ASSIGNEE_ANSWERED`,
      `FFC_PARTNER_FFC_ASSIGNEE_ANSWERED`,
      `SUPPORT_PARTNER_FFC_OPEN`,
      `SUPPORT_PARTNER_FFC_OWNER_ANSWERED`,
      `SUPPORT_PARTNER_PARTNER_OPEN`,
      `SUPPORT_PARTNER_PARTNER_OWNER_ANSWERED`,
      `SUPPORT_PARTNER_SUPPORT_ASSIGNEE_ANSWERED`,
      `SUPPORT_PARTNER_SUPPORT_OWNER_ANSWERED`,
      `FFC_PARTNER_PARTNER_OPEN`,
      `FFC_PARTNER_PARTNER_OWNER_ANSWERED`,
      `FFC_PARTNER_SUPPORT_ASSIGNEE_ANSWERED`,
      `FFC_PARTNER_FFC_OPEN`,
      `FFC_PARTNER_FFC_OWNER_ANSWERED`,
      'FFC_SUPPORT_PARTNER_OPEN',
      'SUPPORT_SUPPORT_SUPPORT_ASSIGNEE_ANSWERED',
      'SUPPORT_SUPPORT_SUPPORT_OWNER_ANSWERED',
      'PARTNER_PARTNER_PARTNER_OWNER_ANSWERED',
      'PARTNER_PARTNER_FFC_OWNER_ANSWERED'
    ],
    WAITING_FOR_CUSTOMER : [
      `PARTNER_FFC_FFC_ASSIGNEE_ANSWERED`,
      `PARTNER_SUPPORT_SUPPORT_ASSIGNEE_ANSWERED`,
      `PARTNER_FFC_SUPPORT_ASSIGNEE_ANSWERED`,
      `PARTNER_SUPPORT_FFC_ASSIGNEE_ANSWERED`,
      `FFC_FFC_PARTNER_OWNER_ANSWERED`,
      `FFC_SUPPORT_PARTNER_OWNER_ANSWERED`,
      `SUPPORT_FFC_PARTNER_OWNER_ANSWERED`,
      `SUPPORT_SUPPORT_PARTNER_OWNER_ANSWERED`,
      `PARTNER_PARTNER_PARTNER_PENDING`,
      `PARTNER_FFC_PARTNER_PENDING`,
      `PARTNER_SUPPORT_PARTNER_PENDING`,
      `SUPPORT_PARTNER_PARTNER_PENDING`,
      `SUPPORT_FFC_PARTNER_PENDING`,
      `SUPPORT_SUPPORT_PARTNER_PENDING`,
      `FFC_PARTNER_PARTNER_PENDING`,
      `FFC_FFC_PARTNER_PENDING`,
      `FFC_SUPPORT_PARTNER_PENDING`,
      `PARTNER_SUPPORT_PARTNER_ASSIGNEE_ANSWERED`,
    ],
    CLOSED : [
      `PARTNER_PARTNER_PARTNER_CLOSED`,
      `PARTNER_PARTNER_SUPPORT_CLOSED`,
      `PARTNER_PARTNER_FFC_CLOSED`,
      `PARTNER_SUPPORT_PARTNER_CLOSED`,
      `PARTNER_SUPPORT_SUPPORT_CLOSED`,
      `PARTNER_SUPPORT_FFC_CLOSED`,
      `PARTNER_FFC_PARTNER_CLOSED`,
      `PARTNER_FFC_SUPPORT_CLOSED`,
      `PARTNER_FFC_FFC_CLOSED`,
      `SUPPORT_PARTNER_PARTNER_CLOSED`,
      `SUPPORT_PARTNER_SUPPORT_CLOSED`,
      `SUPPORT_PARTNER_FFC_CLOSED`,
      `SUPPORT_SUPPORT_PARTNER_CLOSED`,
      `SUPPORT_SUPPORT_SUPPORT_CLOSED`,
      `SUPPORT_SUPPORT_FFC_CLOSED`,
      `SUPPORT_FFC_PARTNER_CLOSED`,
      `SUPPORT_FFC_SUPPORT_CLOSED`,
      `SUPPORT_FFC_FFC_CLOSED`,
      `FFC_PARTNER_PARTNER_CLOSED`,
      `FFC_PARTNER_SUPPORT_CLOSED`,
      `FFC_PARTNER_FFC_CLOSED`,
      `FFC_SUPPORT_PARTNER_CLOSED`,
      `FFC_SUPPORT_SUPPORT_CLOSED`,
      `FFC_SUPPORT_FFC_CLOSED`,
      `FFC_FFC_PARTNER_CLOSED`,
      `FFC_FFC_SUPPORT_CLOSED`,
      `FFC_FFC_FFC_CLOSED`,
    ],
    IN_OTHER_TEAM_PROCESS : [
      "FFC_FFC_FFC_PENDING",
      "FFC_SUPPORT_FFC_PENDING",
      "FFC_PARTNER_FFC_PENDING",
      "SUPPORT_PARTNER_FFC_PENDING",
      "SUPPORT_SUPPORT_FFC_PENDING",
      "SUPPORT_FFC_FFC_PENDING",
      "PARTNER_SUPPORT_FFC_PENDING",
      "PARTNER_PARTNER_FFC_PENDING",
      "PARTNER_FFC_FFC_PENDING",     
    ],
    ANSWERED_TO_TEAM : [
      "SUPPORT_SUPPORT_FFC_OWNER_ANSWERED",
      "PARTNER_SUPPORT_FFC_OWNER_ANSWERED",
      "FFC_SUPPORT_SUPPORT_ASSIGNEE_ANSWERED",
      "FFC_SUPPORT_FFC_ASSIGNEE_ANSWERED",
    ],
    OPENED : [
      "SUPPORT_SUPPORT_SUPPORT_OPEN",
      "SUPPORT_SUPPORT_PARTNER_OPEN",
      "SUPPORT_SUPPORT_FFC_OPEN",  
    ]  
  }

  const calculatSum = (data, statuses, creator) => {
    var filteredStatus = filterStatuses(statuses, creator);
    let total_sum = 0;
    if (filteredStatus !== undefined) {
      filteredStatus.forEach(status => {
        total_sum += (data[status] ?? 0)
      });
    }
    return total_sum;
  }

  const filterStatuses = (statuses, creator) => {
    return statuses.filter( s => s.indexOf(creator) == 0)
  }

  const FilterBoxedByCreator = ({title, data, creator, statuses}) => {
    return (
      <SmallFilterBox
        label={title}
        value={calculatSum(data, statuses, creator)}
        onclick={() => {
          forwardToList(filterStatuses(statuses, creator),`creator.type=${creator}`)
          }
        }
      />
    )
  } 
 
  const ByCreatorGridItem = ({title, data, creator}) =>  {
    return (
      <Grid item md={4} className="text-center">
      <div className={classes.filterContainer}>
        <h3>{title}</h3>
        <FilterBoxedByCreator title= 'نیازمند بررسی' data={data} creator={creator} statuses={statusMap.REQUIRE_ATTENTION}  />
        <FilterBoxedByCreator title= 'در انتظار پاسخ مشتری' data={data} creator={creator} statuses={statusMap.WAITING_FOR_CUSTOMER} />
        <FilterBoxedByCreator title= 'بسته شده' data={data} creator={creator} statuses={statusMap.CLOSED} />
        <FilterBoxedByCreator title= 'درحال بررسی تیم' data={data} creator={creator} statuses={statusMap.IN_OTHER_TEAM_PROCESS} />
        {creator == 'SUPPORT' ? <FilterBoxedByCreator title= 'ایجاد شده' data={data} creator={creator} statuses={statusMap.OPENED} /> : ''}
        {creator == 'FFC' ? <FilterBoxedByCreator title= 'پاسخ به تیم' data={data} creator={creator} statuses={statusMap.ANSWERED_TO_TEAM} /> : '' }
      </div>
    </Grid>
    )
  };

  const calculatSumByCategory = (data, statuses, category) => {
    let total_sum = 0;
    statuses.forEach(status => {
      total_sum += (data ? (data[`${status}_${category}`] ?? 0) : 0)
    });
    return total_sum;
  }

  const FilterBoxedByCatgory = ({title, data, category, statuses}) => {
    return (
     <SmallFilterBox
        label= {title}
        value={calculatSumByCategory(data, statuses, category)}
        onclick={() => forwardToList(statuses, `category.code=${category}`)}
      />
    )
  } 
  
  const ByCategoryGridItem = ({title, data, category}) => {
    return (
      <Grid item md className="text-center">
        <div className={classes.filterContainer}>
          <h3>{title}</h3>
          <FilterBoxedByCatgory title= 'نیازمند بررسی' data={data} category={category} statuses={statusMap.REQUIRE_ATTENTION}/>
          <FilterBoxedByCatgory title= 'در انتظار پاسخ مشتری' data={data} category={category} statuses={statusMap.WAITING_FOR_CUSTOMER}/>
          <FilterBoxedByCatgory title= 'بسته شده' data={data} category={category} statuses={statusMap.CLOSED}/>        
          <FilterBoxedByCatgory title= 'درحال بررسی تیم' data={data} category={category} statuses={statusMap.IN_OTHER_TEAM_PROCESS}/>
          <FilterBoxedByCatgory title= 'پاسخ به تیم' data={data} category={category} statuses={statusMap.ANSWERED_TO_TEAM}/>        
          <FilterBoxedByCatgory title= 'ایجاد شده' data={data} category={category} statuses={statusMap.OPENED}/>   
        </div>
      </Grid>
    )
  };
  
  return (
    <React.Fragment>
      <Grid container item xs={12} sm={12} alignItems="center" style={{ marginBottom: "16px" }}>
        <Typography variant="h6" component="div">
          پشتیبانی
        </Typography>
      </Grid>
      <div className={classes.mainContainer}>
        <Grid
          container
          direction="row"
          spacing={1}
          alignItems="center"
          style={{ marginBottom: "24px" }}
        >
          <Grid item>
            <Button
              variant="contained"
              size="small"
              color="primary"
              onClick={() => setOpenMsg(true)}
            >
              {`تیکت جدید`}
            </Button>
          </Grid>
          <Grid item>
            <Link to="/ticketing-list">
              <Button variant="outlined" size="small" color="secondary">
                لیست تیکت ها
              </Button>
            </Link>
          </Grid>
        </Grid>
        
        <Grid  container spacing={2} style={{ marginBottom: "20px" }}>
          <ByCreatorGridItem title= 'ایجاد کننده: مشتری' data={cardCounts} creator= 'PARTNER'/>
          <ByCreatorGridItem title= 'ایجاد کننده: پشتیبانی' data={cardCounts} creator= 'SUPPORT'/>
          <ByCreatorGridItem title= 'ایجاد کننده: تیم ها' data={cardCounts} creator= 'FFC'/>
        </Grid>
        <Grid container spacing={2}>
          <ByCategoryGridItem title = "ورود کالا" data={categoryCount} category="INBOUND"/>
          <ByCategoryGridItem title = "انبارش" data={categoryCount} category="STORAGE"/>
          <ByCategoryGridItem title = "پردازش سفارش" data={categoryCount} category="FULFILLMENT"/>
        </Grid>
        <Grid container spacing={2}>
          <ByCategoryGridItem title = "فرا ارسال" data={categoryCount} category="DELIVERY"/>
          <ByCategoryGridItem title = "فنی" data={categoryCount} category="TECH"/>
          <ByCategoryGridItem title = "مالی" data={categoryCount} category="FINANCIAL"/>
        </Grid>
        <Grid container spacing={2}>
          <ByCategoryGridItem title = "بازگشت به انبار" data={categoryCount} category="RETURNED"/>
          <ByCategoryGridItem title = "ملزومات بسته بندی" data={categoryCount} category="PACKAGING"/>
          <ByCategoryGridItem title = "محتوا" data={categoryCount} category="CONTENT"/>
        </Grid>
        <Grid container spacing={2}>
          <ByCategoryGridItem title = "قرارداد و توافق" data={categoryCount} category="CONTRACT"/>
          <ByCategoryGridItem title = "راهنمایی و آموزش" data={categoryCount} category="HELP"/>
          <ByCategoryGridItem title = "سایر موارد" data={categoryCount} category="OTHERS"/>
        </Grid>
      </div>
      <Dialog
        open={openMsg}
        onClose={handleCloseModal}
        aria-labelledby="responsive-dialog-title"
        maxWidth="sm"
        fullWidth
        style={{ padding: "16px" }}
      >
        <DialogTitle>
          <Grid container justifyContent="center" justify="center">
            <p style={{ marginTop: "-8px" }}>ایجاد تیکت جدید</p>
          </Grid>
        </DialogTitle>

        <Grid container direction="column">
          <CreateTicket
            handleCloseModal={handleCloseModal}
            getTickets={getTickets}
          />
        </Grid>
      </Dialog>
    </React.Fragment>
  );
};

export default Ticketing;
